import React, { useEffect, useState } from 'react'

import { useShop } from 'shop/hooks'
import { LoaderProps } from './types'
import { useConsumerCart } from 'shop/hooks/useConsumerCart'
import { getCurrentCartId, isCartDateExpired } from 'shop/components/Cart/utils'

export const CartLoader = ({
  isParentLoaded = true,
  children
}: LoaderProps) => {
  const [isLoading, setIsLoading] = useState(false)
  const {
    clearConsumerCart,
    cart: consumerCart,
    getConsumerCart
  } = useConsumerCart()
  const { config, currentPartnerStore } = useShop()

  const storeName = currentPartnerStore?.name
  const cartId = getCurrentCartId(config.domain)

  const clearCart = () => {
    clearConsumerCart()
    localStorage.removeItem(config.domain)
  }

  /** Gets cart on init if there is a cart id */
  useEffect(() => {
    if (cartId && storeName) {
      const loadCartFromId = async () => {
        if (isLoading) return
        setIsLoading(true)

        if (consumerCart?.id) {
          setIsLoading(false)
          return
        }

        try {
          getConsumerCart().then((cart) => {
            // If cart is expired, clear it before page load
            if (isCartDateExpired(cart?.fulfillment)) {
              clearCart()
              setIsLoading(false)
              return
            }
          })
          setIsLoading(false)
        } catch (err) {
          setIsLoading(false)
          console.log(err)
        }
      }
      loadCartFromId()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartId, storeName])

  return (
    <React.Fragment>{children(!isLoading && isParentLoaded)}</React.Fragment>
  )
}
